














































































import {Vue, Component, Watch} from 'vue-property-decorator';
import {
	CompanyDocument as CompanyDocumentData,
	CompanyDocumentType,
	CompanyDocumentUploadItem,
	CompanyDocumentsDTO,
	CompanyDocumentsSettings,
	UploadCompanyDocumentsPayload
} from "@/dto/company/CompanyDetailsDTO";
import Application from "@/state/Application";
import CompanyService from "@/services/CompanyService";
import StringUtils from "@/utils/StringUtils";
import {processError} from "@/utils/ComponentUtils";
import CompanyDocument from "@/components/profile/company/documents/CompanyDocument.vue";
import Notifications from "@/state/Notifications";
import History from "@/components/history/History.vue";
import {HistoryDomen} from "@/components/history/dto/HistoryDomen";
import ChangeActions from "@/components/history/dto/ChangeActions";
import RightSideBar from "@/components/payroll/business/services/RightSideBar.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";

@Component({
	components: {History, CompanyDocument, RightSideBar, PortalCheckbox}
})
export default class CompanyDocuments extends Vue {

	get ChangeActions() {
		return ChangeActions
	}

	get HistoryDomen() {
		return HistoryDomen
	}

	get CompanyDocumentType() {
		return CompanyDocumentType
	}

	get allDocumentTypes() {
		return Object.values(CompanyDocumentType)
	}

	private docs: CompanyDocumentsDTO | null = null
	private settings: CompanyDocumentType[] = []
	private showSettings = false
	private selectedSettings: CompanyDocumentType[] = []

	public mounted(): void {
		this.loadDocuments();
		this.loadSettings();
	}

	private loadSettings() {
		CompanyService.getDocumentsSettings(this.$wss.getCurrent.id).then(
			res => {
				this.settings = res.data.typesDisplaySettings
			},
			err => processError(err, this)
		)
	}

	private loadDocuments() {
		Application.startLoading()
		CompanyService.getDocuments().then(
			res => {
				const documents = res.data
				const docsDto = new CompanyDocumentsDTO()
				this.allDocumentTypes.forEach(type => {
					docsDto.documents[type as CompanyDocumentType] = null
					docsDto.documentIds[type as CompanyDocumentType] = null
				})
				documents.forEach(doc => {
					docsDto.documents[doc.type] = doc.document
					docsDto.documentIds[doc.type] = doc.id
				})
				this.docs = docsDto
				Application.stopLoading()
			},
			err => processError(err, this)
		)
	}

	private uploadDocuments(): void {
		Application.startLoading()
		const documents: CompanyDocumentUploadItem[] = []
		if (this.docs) {
			Object.keys(this.docs.documents).forEach(type => {
				const file = this.docs!.documents[type as CompanyDocumentType]
				if (file) {
					documents.push({type: type as CompanyDocumentType, file: file})
				}
			})
		}
		CompanyService.uploadDocuments(
			new UploadCompanyDocumentsPayload(
				{
					companyId: this.$wss.getCurrent.id,
					documents: documents
				}
			)
		).then(
			() => {
				Notifications.success("The document has been updated successfully!");
				this.loadDocuments()
			},
			err => processError(err, this)
		)
	}

	private deleteDocument(type: CompanyDocumentType): void {
		if (!this.docs) return
		const id = this.docs.documentIds[type]

		if (id) {
			Application.startLoading()
			CompanyService.deleteDocument(this.$wss.getCurrent.id, id).then(
				() => {
					Notifications.success("The document has been deleted successfully!");
					this.loadDocuments()
				},
				err => processError(err, this)
			)
		}
	}

	private openSettings() {
		this.selectedSettings = [...this.settings]
		this.showSettings = true
	}

	private saveSettings() {
		Application.startLoading()
		CompanyService.updateDocumentsSettings(this.$wss.getCurrent.id, [...this.selectedSettings]).then(
			() => {
				this.settings = [...this.selectedSettings]
				this.showSettings = false
				Notifications.success("Settings updated successfully!")
				Application.stopLoading()
			},
			err => processError(err, this)
		)
	}

	private toggleSetting(type: CompanyDocumentType, checked: boolean) {
		if (checked) {
			if (!this.selectedSettings.includes(type)) {
				this.selectedSettings.push(type)
			}
		} else {
			this.selectedSettings = this.selectedSettings.filter(t => t !== type)
		}
	}

	private formatType(type: string): string {
		if (!type) return ""
		const key = `documents.type.${type}`
		const translation = this.$t(key)
		if (translation !== key) {
			return translation as string
		}
		return StringUtils.enumToFormattedSentence(type)
	}

}

